// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"75a828e5","71":"e4fa8ca2","198":"a6ce17e4","354":"4afa7e57","509":"7fe3dbb0","523":"b3fcb12e","664":"b061044a","734":"70d824e7","830":"492d8b5f"}[chunkId] + ".chunk.js";
};